<!-- Referral Button -->
@if (canSeeReferralButton) {
  <button
    class="menu-button has-icon"
    mat-menu-item
    (click)="referAFriendClicked()"
  >
    <emperor-icon name="user_share_1"></emperor-icon>
    <span class="mat-label-large">Refer a friend!</span>
  </button>
}
<!-- Logout Button -->
<button
  class="menu-button has-icon logout-button"
  mat-menu-item
  (click)="logoutClicked()"
>
  <emperor-icon name="logout_2"></emperor-icon>
  <span class="mat-label-large">Log Out</span>
</button>
